export function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-gray-950">
      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
              className="h-6 w-6"
              aria-hidden="true"
            >
              <rect width="32" height="32" rx="6" fill="#7c3aed" />
              <rect x="5" y="5" width="22" height="22" rx="3" fill="none" stroke="#c4b5fd" strokeWidth="2" />
              <rect x="10" y="10" width="12" height="12" rx="2" fill="none" stroke="#a78bfa" strokeWidth="1.5" />
              <rect x="14" y="14" width="4" height="4" rx="1" fill="#e9d5ff" />
            </svg>
            <span className="text-sm font-semibold text-gray-300">Nested Gameception</span>
          </div>
          <p className="text-xs text-gray-600">
            How many layers deep are you?
          </p>
        </div>
      </div>
    </footer>
  );
}
